export const stats = [
  { id: 1, value: '500+', label: '服务游戏产品', suffix: '' },
  { id: 2, value: '50亿+', label: '累计广告曝光', suffix: '' },
  { id: 3, value: '3.2倍', label: '平均ROI提升', suffix: '' },
  { id: 4, value: '30+', label: '覆盖国家与地区', suffix: '' },
];